/* eslint-disable */
var breakpoints = require('./mediaBreakpoints.json');

function categorycarousel1() {
    return {
        slidesToShow: 6,
        slidesToScroll: 6,
        rows: 0,
        dots: false,
        arrows: true,
        autoplay: false,
        infinite: false,
        speed: 300,
        lazyLoad: 'progressive',        
        prevArrow: '<span class="slick-arrow-left fi fi--carrot-left"></span>',
        nextArrow: '<span class="slick-arrow-right fi fi--carrot-right"></span>',
        responsive: [
            {
                breakpoint: breakpoints.tablet,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: breakpoints.mobile,
                settings: {
                    arrows: false,
                    slidesToShow: 3.5,
                    slidesToScroll: 3
                }
            }
        ]
    };
}

function categorycarousel2() {
    return {
        slidesToShow: 6,
        slidesToScroll: 6,
        rows: 0,
        dots: false,
        arrows: true,
        autoplay: false,
        infinite: false,
        speed: 300,
        lazyLoad: 'progressive',        
        prevArrow: '<span class="slick-arrow-left fi fi--carrot-left"></span>',
        nextArrow: '<span class="slick-arrow-right fi fi--carrot-right"></span>',
        responsive: [
            {
                breakpoint: breakpoints.tablet,
                settings: {
                    autoplay: false,
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: breakpoints.mobile,
                settings: {
                    arrows: false,
                    autoplay: false,
                    slidesToShow: 3.5,
                    slidesToScroll: 3
                }
            }
        ]
    };
}

function categorycarousel3() {
    return {
        slidesToShow: 4,
        slidesToScroll: 4,
        rows: 0,
        dots: false,
        arrows: true,
        autoplay: false,
        infinite: false,
        speed: 300,
        lazyLoad: 'progressive',        
        prevArrow: '<span class="slick-arrow-left fi fi--carrot-left"></span>',
        nextArrow: '<span class="slick-arrow-right fi fi--carrot-right"></span>',
        responsive: [
            {
                breakpoint: breakpoints.tablet,
                settings: {
                    autoplay: false,
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: breakpoints.mobile,
                settings: {
                    arrows: false,
                    autoplay: false,
                    slidesToShow: 2.5,
                    slidesToScroll: 2
                }
            }
        ]
    };
}

function categorycarousel4() {
    return {
        slidesToShow: 3,
        slidesToScroll: 3,
        rows: 0,
        dots: false,
        arrows: true,
        autoplay: false,
        infinite: false,
        speed: 300,
        lazyLoad: 'progressive',        
        prevArrow: '<span class="slick-arrow-left fi fi--carrot-left"></span>',
        nextArrow: '<span class="slick-arrow-right fi fi--carrot-right"></span>',
        responsive: [
            {
                breakpoint: breakpoints.tablet,
                settings: {
                    autoplay: false,
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: breakpoints.mobile,
                settings: {
                    arrows: false,
                    autoplay: false,
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }
        ]
    };
}

function productcarousel1() {
    return {
        slidesToShow: 4,
        slidesToScroll: 4,
        rows: 0,
        dots: false,
        arrows: true,
        autoplay: false,
        infinite: false,
        speed: 300,
        lazyLoad: 'progressive',        
        prevArrow: '<span class="slick-arrow-left fi fi--carrot-left"></span>',
        nextArrow: '<span class="slick-arrow-right fi fi--carrot-right"></span>',
        responsive: [
            {
                breakpoint: breakpoints.tablet,
                settings: {
                    autoplay: false,
                    slidesToShow: 2.5,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: breakpoints.mobile,
                settings: {
                    arrows: false,
                    autoplay: false,
                    slidesToShow: 1.5,
                    slidesToScroll: 1
                }
            }
        ]
    };
}

function productcarousel2() {
    return {
        slidesToShow: 4,
        slidesToScroll: 4,
        rows: 0,
        dots: true,
        arrows: true,
        autoplay: false,
        infinite: false,
        speed: 300,
        lazyLoad: 'progressive',        
        prevArrow: '<span class="slick-arrow-left fi fi--carrot-left"></span>',
        nextArrow: '<span class="slick-arrow-right fi fi--carrot-right"></span>',
        responsive: [
            {
                breakpoint: breakpoints.tablet,
                settings: {
                    autoplay: false,
                    slidesToShow: 2.5,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: breakpoints.mobile,
                settings: {
                    arrows: false,
                    dots: false,
                    autoplay: false,
                    slidesToShow: 1.5,
                    slidesToScroll: 1
                }
            }
        ]
    };
}

function productcarousel3() {
    return {
        slidesToShow: 3,
        slidesToScroll: 3,
        rows: 0,
        dots: false,
        arrows: true,
        autoplay: false,
        infinite: false,
        speed: 300,
        lazyLoad: 'progressive',        
        prevArrow: '<span class="slick-arrow-left fi fi--carrot-left"></span>',
        nextArrow: '<span class="slick-arrow-right fi fi--carrot-right"></span>',
        responsive: [
            {
                breakpoint: breakpoints.tablet,
                settings: {
                    slidesToShow: 1.6,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: breakpoints.mobile,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                    arrows: false
                }
            }
        ]
    };
}

function productcarousel4() {
    return {
        slidesToShow: 4,
        slidesToScroll: 4,
        rows: 0,
        dots: false,
        arrows: true,
        autoplay: false,
        infinite: false,
        speed: 300,
        lazyLoad: 'progressive',        
        prevArrow: '<span class="slick-arrow-left fi fi--carrot-left"></span>',
        nextArrow: '<span class="slick-arrow-right fi fi--carrot-right"></span>',
        responsive: [
            {
                breakpoint: breakpoints.tablet,
                settings: {
                    autoplay: false,
                    slidesToShow: 1.5,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: breakpoints.mobile,
                settings: {
                    arrows: false,
                    dots: false,
                    autoplay: false,
                    slidesToShow: 1.5,
                    slidesToScroll: 1
                }
            }
        ]
    };
}

function slider() {
    return {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        autoplay: false,
        rows: 0,
        dots: false,
        arrows: true,
        speed: 300,
        prevArrow: '<span class="slick-arrow-left fi fi--carrot-left"></span>',
        nextArrow: '<span class="slick-arrow-right fi fi--carrot-right"></span>',
        lazyLoad: 'ondemand'
    };
}

function recommendations() {
    return {
        slidesToShow: 4,
        slidesToScroll: 1,
        rows: 0,
        dots: false,
        arrows: true,
        prevArrow: '<span class="slick-arrow-left fi fi--carrot-left"></span>',
        nextArrow: '<span class="slick-arrow-right fi fi--carrot-right"></span>',
        infinite: true,
        useTransform: false,
        speed: 300,
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: breakpoints.ls,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: breakpoints.md,
                settings: {
                    slidesToShow: 2
                }
            }
        ]
    };
}

function heroCarousel() {
    return {
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3500,
        infinite: true,
        speed: 500,
        fade: true,
        adaptiveHeight: true
    };
}

module.exports = {
    categorycarousel1: categorycarousel1,
    categorycarousel2: categorycarousel2,
    categorycarousel3: categorycarousel3,
    categorycarousel4: categorycarousel4,
    productcarousel1: productcarousel1,
    productcarousel2: productcarousel2,
    productcarousel3: productcarousel3,
    productcarousel4: productcarousel4,
    slider: slider,
    recommendations: recommendations,
    heroCarousel: heroCarousel
};
